import { NgModule } from '@angular/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CommonModule } from '@angular/common';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { MemberSendSelectionComponent } from './member-send-selection.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        DialogsModule,
        PopupModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        LabelModule,
        ButtonModule,
        ButtonsModule,
        DropDownsModule,
        PipesModule,
    ],
    declarations: [
        MemberSendSelectionComponent
    ],
    exports: [
        MemberSendSelectionComponent
    ]
})
export class MemberSendSelectionModule { }
